export default "__VITE_PUBLIC_ASSET__233d5a71__"